<template>
    <div class="grade-bar-container">
        <DesktopView ref="desktopView"
            :full="full"
            :loading="loading"
            :learningResultDialog="learningResultDialog"
            :diagnosticsResultDialog="diagnosticsResultDialog"
        />
        <MobileView
            ref="mobileView"
            :learningResultDialog="learningResultDialog"
            :diagnosticsResultDialog="diagnosticsResultDialog"
        />
        <LearningResultDialog ref="learningResultDialog" @loaded="learningResultDialog.loading = false"/>
        <DiagnosticsResultDialog ref="diagnosticsResultDialog" @loaded="diagnosticsResultDialog.loading = false" />
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import DesktopView from './desktopView.vue';
import MobileView from './mobileView.vue';
import LearningResultDialog from '../../TestResultDialog/Learning/index.vue';
import DiagnosticsResultDialog from '../../TestResultDialog/Diagnostics/index.vue';

export default {
    name: 'ResultsTable',
    components: { DesktopView, MobileView, LearningResultDialog, DiagnosticsResultDialog },
    props: {
        full: Boolean,
        loading: Boolean
    },
    data: () => ({
        learningResultDialog: {
            loading: false,
            id: null,
            ref: null,
            open(userId, testId, resultId) {
                this.loading = true;
                this.id = resultId;
                this.ref.reset(userId, testId, resultId);
            }
        },
        diagnosticsResultDialog: {
            loading: false,
            id: null,
            ref: null,
            open(userId, testId, resultId) {
                this.loading = true;
                this.id = resultId;
                let input = {
                    assignId: null,
                    userId: userId,
                    testId: testId,
                    resultId: resultId
                };
                this.ref.reset(input);
            }
        }
    }),
    methods: {
        getPageSize() {
            return this.$refs.desktopView.getPageSize();
        },
        update(data, filters, fromArchive) {
            this.$refs.desktopView.update(data, filters, fromArchive);
            this.$refs.mobileView.update(data, fromArchive);
        }
    },
    mounted() {
        this.learningResultDialog.ref = this.$refs.learningResultDialog;
        this.diagnosticsResultDialog.ref = this.$refs.diagnosticsResultDialog;
    }
}
</script>
